export const AvOptions = [
  {
    key: "empty",
    text: "",
    value: "",
  },
  { key: "11", text: "PL-", value: "PL-" },
  { key: "10", text: "PL+", value: "PL+" },
  { key: "1Q", text: "MDM", value: "MDM" },
  { key: "1", text: "CLD1", value: "CLD1" },
  { key: "2", text: "CLD2", value: "CLD2" },
  { key: "3", text: "CLD3", value: "CLD3" },
  { key: "4", text: "1/10", value: "1/10" },
  { key: "5", text: "2/10", value: "2/10" },
  { key: "6", text: "3/10", value: "3/10" },
  { key: "7", text: "4/10", value: "4/10" },
  { key: "8", text: "5/10", value: "5/10" },
  { key: "9", text: "6/10", value: "6/10" },
  { key: "14", text: "7/10", value: "7/10" },
  { key: "15", text: "8/10", value: "8/10" },
  { key: "16", text: "9/10", value: "9/10" },
  { key: "17", text: "10/10", value: "10/10" },
  { key: "18", text: "11/10", value: "11/10" },
  { key: "19", text: "12/10", value: "12/10" },
  { key: "13/10", text: "13/10", value: "13/10" },
  { key: "14/10", text: "14/10", value: "14/10" },
  { key: "15/10", text: "15/10", value: "15/10" },
];
export const MonthsOptions = [
  { key: "1", text: "Janvier", value: "01" },
  { key: "2", text: "Février", value: "02" },
  { key: "3", text: "Mars", value: "03" },
  { key: "4", text: "Avril", value: "04" },
  { key: "5", text: "Mai", value: "05" },
  { key: "6", text: "Juin", value: "06" },
  { key: "7", text: "Juillet", value: "07" },
  { key: "8", text: "Aôut", value: "08" },
  { key: "9", text: "Séptembre", value: "09" },
  { key: "14", text: "Octobre", value: "10" },
  { key: "15", text: "Novembre", value: "11" },
  { key: "16", text: "Décembre", value: "12" },
];
export const YearsOptions = [
  { key: "1", text: "2021", value: "2021" },
  { key: "2", text: "2022", value: "2022" },
  { key: "3", text: "2023", value: "2023" },
  { key: "4", text: "2024", value: "2024" },
  { key: "5", text: "2025", value: "2025" },
  { key: "6", text: "2026", value: "2026" },
  { key: "7", text: "2027", value: "2027" },
  { key: "8", text: "2028", value: "2028" },
  { key: "9", text: "2029", value: "2029" },
  { key: "10", text: "2030", value: "2030" },
  { key: "11", text: "2031", value: "2031" },
  { key: "12", text: "2032", value: "2032" },
  { key: "13", text: "2033", value: "2033" },
  { key: "14", text: "2034", value: "2034" },
  { key: "15", text: "2035", value: "2035" },
  { key: "16", text: "2036", value: "2036" },
  { key: "17", text: "2037", value: "2037" },
  { key: "18", text: "2038", value: "2038" },
  { key: "19", text: "2039", value: "2039" },
];
export const MedecinOptions = [
  { key: "1", text: "Dr.HANANE ANIBA", value: 3 },
  // { key: "2", text: "Badreddine Badri", value: 4 },
];
export const MedecinOptionsSpecial = [
  { key: "0", text: "Global", value: 0 },
  { key: "1", text: "Dr.HANANE ANIBA", value: 3 },
  // { key: "2", text: "Badreddine Badri", value: 4 },
];
export const mutualisteOptions = [
  { key: "3", text: "Les deux", value: 3 },
  { key: "1", text: "Sans", value: 0 },
  { key: "2", text: "Avec", value: 1 },
];
export const opereOptions = [
  { key: "1", text: "Non", value: 0 },
  { key: "2", text: "Oui", value: 1 },
];
export const SalleOptions = [
  { key: "1", text: "En cours", value: 1 },
  { key: "2", text: "Terminé", value: 2 },
  { key: "3", text: "Archive", value: 3 },
];
